@let s = summary();
<section class="guide" aria-labelledby="signing-guide-title">
  <h3 id="signing-guide-title" class="guide__title">
    <i class="pi pi-pen-to-square" aria-hidden="true"></i>
    Quem acionar para assinar pela empresa
  </h3>

  @if (s.empty) {
    <p class="guide__empty">
      O contrato lido não traz regra de assinatura. Confirme com a empresa quem a representa antes
      de levar um contrato para assinar.
    </p>
  } @else {
    <ul class="situations">
      @for (situation of s.situations; track situation.key) {
        <li class="situation prov-row">
          <span class="situation__icon" aria-hidden="true">
            <i class="pi" [class]="'pi ' + situation.icon"></i>
          </span>
          <div class="situation__body">
            <p class="situation__title">{{ situation.title }}</p>
            @if (situation.usesGeneral) {
              <p class="situation__fallback">Contrato não especifica: usar a regra geral.</p>
            }
            @for (line of situation.lines; track $index) {
              <p class="line">
                @if (line.people.length > 0) {
                  <span class="line__people">
                    @for (person of line.people; track person.name; let last = $last) {
                      <b>{{ person.name }}</b>
                      @if (person.role) {
                        <span class="line__role">({{ person.role }})</span>
                      }
                      @if (!last) {
                        <span class="line__sep">{{
                          line.combination.startsWith('qualquer') ? 'ou' : 'e'
                        }}</span>
                      }
                    }
                  </span>
                  <span class="line__arrow" aria-hidden="true">→</span>
                }
                <span
                  class="line__combination"
                  [class.line__combination--approval]="line.people.length === 0"
                  >{{ line.combination }}</span
                >
                @if (line.limit) {
                  <span class="line__limit">{{ line.limit }}</span>
                }
                <app-charter-provenance [from]="line.source" [current]="true" variant="icon" />
              </p>
              @if (line.readText) {
                <p class="line__read">"{{ line.readText }}"</p>
              }
            }
            @for (q of situation.quorum; track $index) {
              <p class="quorum">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                {{ q.text }}
                <app-charter-provenance [from]="q.source" [current]="true" variant="icon" />
              </p>
            }
          </div>
        </li>
      }

      <li class="situation prov-row">
        <span class="situation__icon" aria-hidden="true"><i class="pi pi-id-card"></i></span>
        <div class="situation__body">
          <p class="situation__title">Procurações</p>
          @if (s.attorneys; as a) {
            <p class="line">
              <span class="line__combination">{{ a.text }}</span>
              <app-charter-provenance [from]="a.source" [current]="true" variant="icon" />
            </p>
          } @else {
            <p class="situation__fallback">Contrato não especifica.</p>
          }
        </div>
      </li>
    </ul>
  }
</section>
